import styled from 'styled-components';
import { BlankSpace } from '../genericComponents/layouts';
import {
  CardTitle, Text3, Text4B,
} from '../genericComponents/texts';
// import reportImg from '../assets/img/report.svg';
import { priceFormat } from '../priceFormat';

interface Props {
  vehicle:{
    completeName:string,
    autofactPrice?: number;
    carouselImages: string[];
    patent?: string;
    mileage?: number;
    color?: string;
    year?: number;
    transmission?: string;
    engine?: string;
    sinister: boolean;
    technicalInspection: boolean;
    region: number;
  };
  // eslint-disable-next-line @typescript-eslint/ban-types
}

export default function ConsultVehiclePDF(props:Props) {
  const Mensajes = {
    patente: 'No se ha encontrado patente.',
    autofactPrice: 'No se ha encontrado precio autofact.',
    transmission: 'No se ha encontrado transmision.',
    engine: 'No se ha encontrado motor.',
    color: '-',
    mileage: 'No se ha ingresado kilometraje.',
    noApply: 'No aplica',
  };
  const { vehicle } = props;
  const mileageData = vehicle.mileage ? priceFormat(vehicle.mileage) : '-';
  const colorData = vehicle.color ? vehicle.color : Mensajes.color;
  const transmission = vehicle.transmission ? vehicle.transmission : Mensajes.transmission;
  return (
    <Container>
      <DSKContainer1>
        <CardTitle>
          {vehicle.completeName}
        </CardTitle>
        <CarDetails>
          <CardDetailItem title="Patente" value={vehicle.patent && vehicle.patent !== 'null' ? vehicle.patent : Mensajes.noApply} />
          <CardDetailItem title="Kilometraje" value={mileageData} />
          <CardDetailItem title="Color" value={vehicle.patent ? colorData : Mensajes.noApply} />
        </CarDetails>
        <CarDetails>
          <CardDetailItem title="Año" value={`${vehicle.year ? vehicle.year : '-'}`} />
          <CardDetailItem title="Motor" value={vehicle.engine ? vehicle.engine : Mensajes.engine} />
          <CardDetailItem title="Transmisión" value={transmission} />
        </CarDetails>
        <BlankSpace height="10px" />
      </DSKContainer1>
      <DSKcontainer2>
        {vehicle.carouselImages.slice(0, 1).map((image, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <img src={image} key={index} alt="" style={{ maxWidth: '80%', maxHeight: '80%', borderRadius: '10px' }} />
        ))}
      </DSKcontainer2>
    </Container>
  );
}

function CardDetailItem({ title, value }: { title: string, value: string }) {
  return (
    <CarDetailsCont>
      <Text3>{title}</Text3>
      <BlankSpace height="4px" />
      <Text4B>{value}</Text4B>
    </CarDetailsCont>
  );
}

const Container = styled.div`
  padding: 20px 0;
  display: flex;
  flex-direction: row;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;
const CarDetails = styled.div`
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const CarDetailsCont = styled.div`
  width: 16%;
  margin: 10px 0;
  display: flex;
  flex-direction: column;
`;
// const CarDetailSubCont1 = styled.div`
//   width: 30%;
//   display: flex;
//   flex-direction: column;
// `;

const DSKContainer1 = styled.div`
  width: 70%;
  @media (max-width: 700px) {
    width: 100%;
  }
`;
const DSKcontainer2 = styled.div`
  width: 40%;
  height: 140px;
  margin: 0px 0;
  display: flex;
  justify-content: flex-end;
`;
